import { CHECKBOX_COLUMN_PADDING } from '@components/ListV2/components/table/virtualizedTable.styles';
import {
  MIN_SCREEN_HEADER_HEIGHT,
  WORKSPACE_PADDING,
  WORKSPACE_PADDING_MOBILE,
} from '@components/v2/constants';
import { makeStyles } from 'tss-react/mui';

export const useWorkspaceMassActionsSlotStyles = makeStyles()((theme) => ({
  shell: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.drawer - 1,
    display: 'flex',
    alignItems: 'center',
    minHeight: MIN_SCREEN_HEADER_HEIGHT,
    paddingLeft: theme.spacing(WORKSPACE_PADDING + CHECKBOX_COLUMN_PADDING),
    paddingRight: theme.spacing(WORKSPACE_PADDING),
    backgroundColor: theme.palette.accent.dark,
    borderBottom: `1px solid ${theme.palette.custom.border.secondary}`,
    borderTopLeftRadius: theme.shape.borderRadius2xl,
    borderTopRightRadius: theme.shape.borderRadius2xl,
    [theme.breakpoints.down('sm')]: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      paddingLeft: theme.spacing(WORKSPACE_PADDING_MOBILE),
      paddingRight: theme.spacing(WORKSPACE_PADDING_MOBILE),
    },
  },
}));
